import { useCallback } from 'react';
import { useSession } from '@sdk/session/SessionContext';

import { useRemoveReaction } from '@web/conversations/hooks/useRemoveReaction';
import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';

type Props = {
  conversationId: ID;
  emoji: string;
  messageId: ID;
};

export const useRemoveReactionAction = () => {
  const { currentUser } = useSession();
  const { removeReaction } = useConversationActions();
  const mutation = useRemoveReaction();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async (payload: Props) => {
      removeReaction({
        messageId: payload.messageId,
        reaction: payload.emoji,
        userId: currentUser.id,
      });

      await mutateAsync({
        conversationId: payload.conversationId,
        emoji: payload.emoji,
        messageId: payload.messageId,
      });
    },
    [currentUser, mutateAsync, removeReaction]
  );

  return { action, mutation };
};
